// extracted by mini-css-extract-plugin
export var layoutContainer = "_ds-0";
export var layoutContainerNoRounding = "_ds-6";
export var layoutContainerOpen = "_ds-5";
export var layoutContainerResizing = "_ds-1";
export var mainContent = "_ds-2";
export var resizeDivider = "_ds-3";
export var slidePanel = "_ds-4";